import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Radio } from 'antd';
import { PRODUCT_SOURCE_TYPE_OPTION_LIST } from 'constant/pms-product';

const ProductSourceType = ({
  control,
  canEditSourceType,
}: {
  canEditSourceType: boolean;
  control: Control<CreateProductFormSchemaType>;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.product_source)}:</FormLabel>
      <Controller
        name="sourceType"
        control={control}
        render={({ field }) => (
          <Radio.Group
            {...field}
            optionType="button"
            buttonStyle="solid"
            disabled={!canEditSourceType}
          >
            {PRODUCT_SOURCE_TYPE_OPTION_LIST.map(({ value, label }) => {
              return (
                <Radio value={value} key={value}>
                  {label}
                </Radio>
              );
            })}
          </Radio.Group>
        )}
      />
    </div>
  );
};

export default ProductSourceType;
